import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Axios from "axios";
import { Grid } from "@mui/material";
import moment from "moment";
import Controls from "../../subDealerManagement/subdealer/Controls";
import { API_URL_LMS } from "../../../../Constant/index";
import { useForm, Form } from "../../../../components/Form/FormComponent";
import {
  convertToCurrencyFormat,
  convertToCurrencyFormatQuantaty,
  millisecondsToStringDate,
  DATE_FORMAT,
  isRequired,
} from "../../../../_helpers/commonFunctions";
import { withTranslation, useTranslation } from "react-i18next";
// import Controls from "../../Controls";
// import defaultImg from "./defaultImg.png";
// import Axios from "axios";
// import { API_URL_ADMIN} from "../../../../../Constant/index";
import { useDispatch, useSelector } from "react-redux";
// import { getSubDealerAction } from "../../../../../_actions/subDealer.action";
import Popup from "../../../../components/Popup/Popup";
import SearchForm from "./SearchForm";
import RulesAddEditForm from "./RulesAddEditForm";
import DeleteRule from "./DeleteRule";
import { getPointCalulationManualListAction } from "../../../../_actions/subDealer.action";
import ExportExcelPopup from "../../../../components/exportPopup/ExportExcelPopup";
import DataGridProMUI from "../../../../components/DataGrid/DataGridProMUI";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { onExportExcel } from "../../../../_helpers/exportExcel";
import { isPermission, authorizedMessage } from "../../../../_helpers/commonAPI";
import { ToastContainer, toast } from 'react-toastify';
import AuthLoader from "../../../../components/AuthLoader";
import AuthorizedMessagePage from "../../../../components/AuthorizedMessagePage";


const SubDealerActivityPoint = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [isdelete, setIsdelete] = useState(false);
  const [openEditPermissionPopup, setOpenEditPermissionPopup] = useState(null);
  const [openDeleteRulePopup, setOpenDeleteRulePopup] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState({});
  const [recordForDelete, setRecordForDelete] = useState(null);
  const [headerName, setHeaderName] = useState("Add New Rule");
  const dispatch = useDispatch();
  const [isAddEdit, setIsAddEdit] = useState(false);
  const [searchString, setSearchString] = useState("");
  const pointCalculationState = useSelector((state) => state.pointCalculation);
  const pointCalculationReturn = useSelector((state) => state.pointCalculation);
  const [openExportPopup, setOpenExportPopup] = useState(null);
  const [pageSize, setPageSize] = useState(25);
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([])
  const [open, setOpen] = useState(false);
  const [onAddPoint, setOnAddPoint] = useState(false);
  const [exportState, setExportState] = useState("Export");
  const [searchedRows, setSearchedRows] = useState(null)
  const [state, setState] = React.useState({
    message: "Deleted Successfully!!!!",
    severity: "success",
    open: false,
  });
  const [gridData, setGridData] = useState([]);
  const [statusCode, setStatusCode] = useState(null)
  const INITIAL_FORM_VALUES = {
    activeFlag: "All",
    startDate: null,
    endDate: null,
  };
  const ACTIVE_LIST = ["Yes", "No"];

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const onEditClick = async (e) => {
          const isAllow = await isPermission("LoyaltyPointCalculation-PointCalculationRules-edit")
          if (!isAllow) {
            toast.success(authorizedMessage, {
              position: toast.POSITION.TOP_RIGHT
            });
            return 0;
          }
          setHeaderName("EDIT POINT CALCULATION RULES");
          setRecordForEdit(params.row);
          setOpenPopup(true);
          setIsAddEdit(false);
          setOnAddPoint(false)
        };
        const onDeleteClick = async (e) => {
          const isAllow = await isPermission("LoyaltyPointCalculation-PointCalculationRules-delete")
          if (!isAllow) {
            toast.success(authorizedMessage, {
              position: toast.POSITION.TOP_RIGHT
            });
            return 0;
          }
          setRecordForDelete(params.row);
          setOpenDeleteRulePopup(true);
          setIsdelete(false);
        };

        return (
          <div className="Action">
            <EditIcon className="EditIcon" onClick={onEditClick} />
            <DeleteIcon className="DeleteIcon" onClick={onDeleteClick} />
          </div>
        );
      },
    },
    {
      field: "startDate",
      headerName: "Start Date",
      headerAlign: "center",
      align: "center",
      width: 150,
      // renderCell: ({ row }) => {
      //   return moment(parseInt(row.c)).format("DD-MM-YYYY");
      // },
      type: "date",
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    {
      field: "endDate",
      headerName: "End Date",
      headerAlign: "center",
      align: "center",
      width: 150,
      // renderCell: ({ row }) => {
      //   return moment(parseInt(row.endDate)).format("DD-MM-YYYY");
      // },
      type: "date",
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    // {
    //   field: "active",
    //   headerName: "Active",
    //   headerAlign: "center",
    //   align: "center",
    //   width: 150,
    // },
    {
      field: "salesOrganization",
      headerName: "Sales Organization",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "distributionChannel",
      headerName: "Distribution Channel",
      align: "center",
      headerAlign: "center",
      width: 150,
    },
    {
      field: "division",
      headerName: "Division",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "materialGroup",
      headerName: "Material Group 1",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "materialPriceGroup",
      headerName: "Material Pricing Group ",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "expireYear",
      headerName: "Expiry Years",
      align: "center",
      headerAlign: "center",
      width: 150,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      headerAlign: "center",
      align: "right",
      width: 150,
      format: '#,###.000',
      renderCell: ({ row }) => {
        return convertToCurrencyFormatQuantaty(row.quantity);
      },
    },
    {
      field: "subDealerPoint",
      headerName: "Sub Dealer Points",
      headerAlign: "center",
      align: "right",
      width: 150,
      format: '#,##0.00',
      renderCell: ({ row }) => {
        return convertToCurrencyFormat(row.subDealerPoint);
      },
    },
    { field: 'sDate', headerName: 'sDate', hide: true },
    { field: 'eDate', headerName: 'eDate', hide: true },
    { field: 'q', headerName: 'quantity', hide: true },
    // { field: 'dp', headerName: 'dlr pts', hide: true },
    { field: 'sdp', headerName: 'sub dlr pts', hide: true },
  ];
  //export same as report starts here
  const onExportClick = () => {
    const url = `export/point-rule`;
    setExportState("Exporting...");
    let filters = {};
    if (values.activeFlag === "All") {
      filters = {
        "ruleType": "manual",
        "startDate": values.startDate ? moment(values.startDate).format("DD-MM-yyyy") : "",
        "endDate": values.endDate ? moment(values.endDate).format("DD-MM-yyyy") : "",
      }
    } else {
      filters = {
        "ruleType": "manual",
        "startDate": values.startDate ? moment(values.startDate).format("DD-MM-yyyy") : "",
        "endDate": values.endDate ? moment(values.endDate).format("DD-MM-yyyy") : "",
        "activeFlag": values.activeFlag ? values.activeFlag : ""
      }
    }
    Axios({
      method: "POST",
      url: API_URL_LMS + url,
      data: filters,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        setExportState("Export");
        setOpen(true);
        setFileUrl(response.data.data);
        exportExcelFile(response.data.data);
      })
      .catch((err) => { setExportState("Export"); });
  }


  function exportExcelFile(file_url) {
    setExportFiles([])
    Axios({
      method: "GET", url: API_URL_LMS + `export/bucket?folderName=${file_url}`,
      headers: {
        "Content-Type": "application/json",
        'X-AUTH-TOKEN': localStorage.getItem('x-auth-token'),
        'X-SOLD-TO-ID': localStorage.getItem('CustomerNumber')
      }
    })
      .then(async (response) => {
        const newRes = Array.isArray(response.data.data) ? response.data.data : []
        setExportFiles(newRes)
      }).catch((err) => {
        // setExportState({ btnName: "EXPORT" });
      })
  }
  //export same as report ends here.
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    // for single input validation we need to check if this feild is there are not
    if ("subDealerNumber" in fieldValues)
      temp.subDealerNumber = isRequired(fieldValues.subDealerNumber)
        ? ""
        : "Sub Dealer Number is required.";

    if ("startDate" in values && values.endDate != null) {
      temp.startDate =
        values.startDate > values.endDate
          ? "Start date Should be lesser than End date"
          : "";
    }

    setErrors({
      ...temp,
    });
    // to check all of the properties inside temp function is an empty string(i.e. valid)
    // we will return this only if the validate is method is called from Onsubmit method
    if (fieldValues == values)
      return Object.values(temp).every((eachFieldErr) => eachFieldErr == "");
  };
  const { values, setValues, handleInputChange, errors, setErrors } = useForm(
    INITIAL_FORM_VALUES,
    true,
    validate
  );

  React.useEffect(() => {
    if (values.startDate && values.endDate) validate();
  }, [values.startDate, values.endDate]);

  React.useEffect(() => {
    if (isAddEdit === true && openPopup === false)
      dispatch(getPointCalulationManualListAction(searchString));
  }, [isAddEdit, openPopup]);

  const resetSearch = () => {
    setValues({ activeFlag: "All", startDate: null, endDate: null });
    setErrors({})
  };

  React.useEffect(() => {
    let queryString = "";
    if (validate()) {
      if (values.activeFlag === "All") {
        queryString = `?ruleType=manual${values.startDate
          ? "&&startDate=" + moment(values.startDate).format("DD-MM-yyyy")
          : ""
          }${values.endDate
            ? "&&endDate=" + moment(values.endDate).format("DD-MM-yyyy")
            : ""
          }`;
      } else {
        queryString = `?ruleType=manual${values.activeFlag ? "&&activeFlag=" + values.activeFlag : ""
          }${values.startDate
            ? "&&startDate=" + moment(values.startDate).format("DD-MM-yyyy")
            : ""
          }${values.endDate
            ? "&&endDate=" + moment(values.endDate).format("DD-MM-yyyy")
            : ""
          }`;
      }
      setSearchString(queryString);
      dispatch(getPointCalulationManualListAction(queryString));
    }
  }, [values.activeFlag, values.startDate, values.endDate]);

  React.useEffect(() => {
    if (isdelete === true && openDeleteRulePopup === false)
      dispatch(getPointCalulationManualListAction("?ruleType=manual"));
  }, [isdelete, openDeleteRulePopup]);

  useEffect(() => {
    const gridData =
      pointCalculationState &&
      pointCalculationState.manual &&
      pointCalculationState.manual.manualRuleList &&
      pointCalculationState.manual.manualRuleList.data &&
      pointCalculationState.manual.manualRuleList.data.map((e, i) => {
        return {
          ...e,
          // startDateString: millisecondsToStringDate(
          //   e.startDate,
          //   DATE_FORMAT
          // ),
          // endDateString: millisecondsToStringDate(
          //   e.endDate,
          //   DATE_FORMAT
          // ),
          startDate: e.startDate != null ? new Date(e.startDate) : "",
          endDate: e.endDate != null ? new Date(e.endDate) : "",
          sDate: e.startDate != null ? moment(new Date(e.startDate)).format("DD-MM-yyyy") : "",
          eDate: e.endDate != null ? moment(new Date(e.endDate)).format("DD-MM-yyyy") : "",
          // q: convertToCurrencyFormatQuantaty(item.quantity),
          q: convertToCurrencyFormatQuantaty(e.quantity),
          // dp: convertToCurrencyFormat(e.dealerPoint),
          sdp: convertToCurrencyFormat(e.subDealerPoint)
        };
      });
    setGridData(gridData);
    const sCode = pointCalculationState && pointCalculationState.errorMessage && pointCalculationState.errorMessage.status
    setStatusCode(sCode)
  }, [
    pointCalculationState &&
    pointCalculationState.manual &&
    pointCalculationState.manual.manualRuleList &&
    pointCalculationState.manual.manualRuleList.data,
  ]);

  function modifyColumns(columns) {
    // columns = columns.filter(function(el) { return el.field != "actions"; });
    columns = columns.filter((item) => !["actions", "sDate", "eDate", "q", "sdp"].includes(item.field))
    return columns.map((item) => {
      return ({
        label: item.headerName,
        value: item.field,
        ...item
      })
    })
  }

  function modifyRows(rowdata) {
    // let filteredRow = searchedRows.map((item) => item.model);
    let filteredRow = rowdata.map((item) => item.model);
    const data = filteredRow.map((item) => {
      return ({
        ...item
      })
    })
    return data
  }

  async function callExcelExport(data) {
    const isAllow = await isPermission("LoyaltyPointCalculation-PointCalculationRules-view")
    if (!isAllow) {
      toast.success(authorizedMessage, {
        position: toast.POSITION.TOP_RIGHT
      });
      return 0;
    }

    const fileName = `POINT_CALCULATION_RULE_MANUAL_${moment(new Date()).format("DDMMyyyy")}`;
    const sheetName = `RULE_MANUAL`
    onExportExcel(modifyColumns(columns), modifyRows(data), fileName, sheetName)
  }

  useEffect(()=>{
    console.log("Actions =>",pointCalculationReturn.authError)
    setStatusCode(pointCalculationReturn.authError)
  },[pointCalculationReturn])

  return (
    <>
      {pointCalculationState.loading ? <AuthLoader /> : statusCode === 401 ? <AuthorizedMessagePage /> :
        <>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={state.open}
            autoHideDuration={6000}
            key={"topright"}
          >
            <Alert
              severity={state.severity}
              sx={{ width: "100%" }}
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setState({ open: false });
                  }}
                >
                  Close
                </Button>
              }
            >
              {state.message}
            </Alert>
          </Snackbar>

          <>
            <div className="pCalFormControll">
              <Grid container>
                <Grid item md={3} xs={12}>
                  <Controls.DatePicker
                    name="startDate"
                    label="Start Date"
                    helperText=""
                    value={values.startDate ? values.startDate : null}
                    onChange={handleInputChange}
                    maxDate={values.endDate}
                    error={errors.startDate}
                  />
                </Grid>

                <Grid item md={3} xs={12}>
                  <Controls.DatePicker
                    name="endDate"
                    label="End Date"
                    value={values.endDate ? values.endDate : null}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <Controls.Select
                    name="activeFlag"
                    label="Active"
                    value={values.activeFlag}
                    onChange={handleInputChange}
                    options={ACTIVE_LIST}
                    error={errors.subDistrict}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <div className="">
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={resetSearch}
                    >
                      Clear All
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </>

          <div className="addPointsRules">
            <Button
              variant="contained"
              className="btncolor"
              onClick={async () => {

                const isAllow = await isPermission("LoyaltyPointCalculation-PointCalculationRules-AddPointCalculationRules-create")
                if (!isAllow) {
                  toast.success(authorizedMessage, {
                    position: toast.POSITION.TOP_RIGHT
                  });
                  return 0;
                }

                setHeaderName("ADD POINT CALCULATION RULES");
                setOpenPopup(true);
                setRecordForEdit(null);
                setIsAddEdit(false);
                setOnAddPoint(true)
              }}
            >
              ADD POINT CALCULATION RULES
            </Button>
          </div>

          <div className="DataGridContainer">
            <ExportExcelPopup
              title={"Customer"}
              fileName={"customer"}
              setOpen={setOpen}
              open={open}
              exportExcelFile={exportExcelFile}
              fileUrl={fileUrl}
              exportFiles={exportFiles}
              onExportClick={onExportClick}
            />
            <DataGridProMUI
              rows={gridData}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              onExportClick={onExportClick}
              exportState={exportState}
              loading={!(gridData || []).length && pointCalculationState.loading}
              setSearchedRows={setSearchedRows}
              callExcelExport={callExcelExport}
              defaultStateChange={false}
            />
          </div>

          <Popup
            title={headerName}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            width={"100%"}
            height={"auto"}
            pt={0}
            pb={5}
            pl={0}
            pr={0}
          >
            <RulesAddEditForm
              setOpenPopup={setOpenPopup}
              recordForEdit={recordForEdit}
              setIsAddEdit={setIsAddEdit}
              onAddPoint={onAddPoint}
            />
          </Popup>

          <Popup
            title={""}
            openPopup={openDeleteRulePopup}
            setOpenPopup={setOpenDeleteRulePopup}
          >
            <DeleteRule
              openPopup={openDeleteRulePopup}
              setOpenPopup={setOpenDeleteRulePopup}
              recordForDelete={recordForDelete}
              setState={setState}
              setIsdelete={setIsdelete}
            />
          </Popup>
        </>
      }
    </>
  );
};

export default withTranslation()(SubDealerActivityPoint);
